import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import getLevel from '../util/get-level';

export function getName() {
  return 'NegativeAdGroupDsaTarget';
}

export function getColumnsMetadata() {
  return _.defaults({
    CampaignName: 'Campaign/Name',
    AdGroupName: 'AdGroup/Name',
    CriterionName: ['Operand1', 'Argument1', 'Operand2', 'Argument2', 'Operand3', 'Argument3'],
  }, PerformanceMetricsColumns);
}

export function getRoute({
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/autotargets/exclusions/adgroup';
    case 'Campaign':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/autotargets/exclusions/adgroup';
    case 'Account':
    default:
      return 'customer/:customer_id/account/:account_id/autotargets/exclusions/adgroup';
  }
}
